const prefix = 'MEDIA';

const TOGGLE_DRAWER = `${prefix}/TOGGLE_DRAWER`;

export {
  TOGGLE_DRAWER, // eslint-disable-line import/prefer-default-export
};
